module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_JEC.0d65c056.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_JEC.png
// module id = 88
// module chunks = 0